<template>
  <nav class="aui-navbar" style="background-color: #fff;" :class="`aui-navbar--${$store.state.navbarLayoutType}`">
    <div class="aui-navbar__header" style="width: 180px;">
      <h1 class="aui-navbar__brand" >
        <a class="aui-navbar__brand-lg" href="javascript:;">
			<img :src="logoImg" />
		</a>
        <!-- <a class="aui-navbar__brand-mini" href="javascript:;">{{ $t('brand.mini') }}</a> -->
      </h1>
    </div>
    <div class="aui-navbar__body">
	  <el-menu
	    :default-active="$store.state.sidebarMenuActiveName"
	    :unique-opened="true"
	    class="aui-navbar__menu ml-auto" mode="horizontal" background-color="#fff" text-color="#000" active-text-color="#577FCB">
	    <!-- <sub-menu v-for="menu in $store.state.sidebarMenuList" :key="menu.id" :menu="menu" /> -->
	    <sub-menu v-for="menu in $store.state.sidebarMenuList" :key="menu.id" :menu="menu"  v-if="role != 'COMPANY' && role != ''"/>
	  </el-menu>
      <el-menu background-color="#fff" text-color="#000" style="margin-right: 20px;" class="aui-navbar__menu" mode="horizontal">
        <el-menu-item index="1" v-show="false">
          <el-button v-if="$store.state.user.superAdmin === 1" type="text" @click.native="tenantHandle()">
            <i class="el-icon-house el-icon--right"></i>{{ $t('tenant.current') }}：{{ $store.state.user.tenantName }}
          </el-button>
          <span v-else><i class="el-icon-house el-icon--right"></i>{{ $t('tenant.current') }}：{{ $store.state.user.tenantName }}</span>
        </el-menu-item>
        <el-menu-item index="2" v-show="false">
          <el-dropdown placement="bottom" :show-timeout="0">
            <el-button size="mini">{{ $t('_lang') }}</el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(val, key) in i18nMessages" :key="key" @click.native="$i18n.locale = key">{{ val._lang }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-menu-item>
        <!--<el-menu-item index="3">
          <a href="//www.renren.io/" target="_blank">
            <svg class="icon-svg aui-navbar__icon-menu" aria-hidden="true"><use xlink:href="#icon-earth"></use></svg>
          </a>
        </el-menu-item>-->
        <!-- <el-menu-item index="1" v-if="$hasPermission('sys:notice:all')">
          <el-badge :is-dot="messageTip">
              <a href="#"  @click="myNoticeRouter()"><i class="el-icon-question"></i>帮助</a>
          </el-badge>
        </el-menu-item> -->
        <!-- <el-menu-item index="2" @click="fullscreenHandle()">
          <svg class="icon-svg aui-navbar__icon-menu" aria-hidden="true"><use xlink:href="#icon-fullscreen"></use></svg>
        </el-menu-item> -->
        <el-menu-item index="2" class="menuBtn">
          <img src="../assets/img/video.png" alt="" @click="$message.error('暂未开放！')">
          <img src="../assets/img/shouce.png" alt="" @click="$message.error('暂未开放！')">
        </el-menu-item>
        <el-menu-item index="3" class="aui-navbar__avatar">
          <el-dropdown placement="bottom" :show-timeout="0">
            <li class="el-dropdown-link" style="display:flex;align-items:center;">
				    <img :src="avatarImg" width="28px" height="28px" style="border-radius: 50%;width: 28px;height: 28px;" />
                <span class="userName">{{ $store.state.user.caName }}{{role == 'COMPANY' ? ($store.state.user.isCaDefault == 0 ? `-${$store.state.user.realName}` : '') :  `${$store.state.user.name}` }}</span>
              <i class="el-icon-arrow-down"></i>
            </li>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-if="role != 'COMPANY'" @click.native="updatePasswordHandle()">{{ $t('updatePassword.title') }}</el-dropdown-item>
              <el-dropdown-item v-else @click.native="fnOpenSetting(1)">安全设置</el-dropdown-item>
              <el-dropdown-item @click.native="fnOpenSetting(2)" v-if="role == 'COMPANY'">基础信息</el-dropdown-item>
              <el-dropdown-item @click.native="logoutHandle()">{{ $t('logout') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-menu-item>
      </el-menu>
    </div>
    <!-- 弹窗, 修改密码 -->
    <update-password v-if="updatePasswordVisible" ref="updatePassword"></update-password>
    <!-- 弹窗, 切换租户 -->
    <switch-tenant v-if="switchTenantVisible" ref="switchTenant"></switch-tenant>
  </nav>
</template>

<script>
import { messages } from '@/i18n'
import screenfull from 'screenfull'
import UpdatePassword from './main-navbar-update-password'
import SwitchTenant from './main-navbar-switch-tenant'
import { clearLoginInfo } from '@/utils'
import SubMenu from './main-sidebar-sub-menu'
import Cookies from 'js-cookie'
import { addDynamicRoute } from '@/router'
export default {
  inject: ['refresh'],
  data () {
    return {
      role: Cookies.get('admin_role'),
      i18nMessages: messages,
      updatePasswordVisible: false,
      switchTenantVisible: false,
      messageTip: false,
	  logoImg: require('../assets/img/logo.png'),
	  avatarImg: require('../assets/img/avatar.png')
    }
  },
  components: {
    UpdatePassword,
    SwitchTenant,
    SubMenu
  },
  created () {
    // this.$nextTick(() => {
      this.role = Cookies.get('admin_role')
    // })
    // this.$http.get(`/sys/user/myRole`).then(({ data: res }) => {
    //     if (res.code !== 0) {
    //       return this.$message.error(res.msg)
    //     }
    //    if (res.data.length == 1) {
    //       this.role = res.data[0]
    //       Cookies.set('admin_role', res.data[0])
    //     }
    // }).catch(() => {})
    // 未读通知数
    this.getUnReadCount()
    this.$store.state.sidebarMenuList = window.SITE_CONFIG['menuList']
  },
  methods: {
    fnOpenSetting(num){
      if(num == 1){
        const routeParams = {
          routeName: `安全设置`,
          title: `安全设置`,
          path: 'sys/updatepassword'
        }
        // 动态路由
        addDynamicRoute(routeParams, this.$router)
      }else{
        const routeParams = {
          routeName: `基础信息`,
          title: `基础信息`,
          path: 'user/qyyh-user'
        }
        // 动态路由
        addDynamicRoute(routeParams, this.$router)
      }
    },
    myNoticeRouter () {
      this.$router.replace('sys-notice-user')
    },
    getUnReadCount () {
      this.$http.get(`/sys/notice/mynotice/unread`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        if (res.data > 0) {
          this.messageTip = true
        }
      }).catch(() => {})
    },
    // 全屏
    fullscreenHandle () {
      if (!screenfull.enabled) {
        return this.$message({
          message: this.$t('fullscreen.prompt'),
          type: 'warning',
          duration: 500
        })
      }
      screenfull.toggle()
    },
    // 切换租户
    tenantHandle () {
      this.switchTenantVisible = true
      this.$nextTick(() => {
        this.$refs.switchTenant.init()
      })
    },
    // 修改密码
    updatePasswordHandle () {
      this.updatePasswordVisible = true
      this.$nextTick(() => {
        this.$refs.updatePassword.init()
      })
    },
    // 退出
    logoutHandle () {
      this.$confirm(this.$t('prompt.info', { 'handle': this.$t('logout') }), this.$t('prompt.title'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        this.$http.post('/auth/oauth/logout').then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          clearLoginInfo()
          this.$router.push({ name: 'login' })
        }).catch(() => {})
      }).catch(() => {})
    }
  }
}
</script>
<style lang="scss" scoped>
  .aui-navbar__menu .el-menu-item, .aui-navbar__menu .el-submenu > .el-submenu__title{
    padding:0 20px !important;
  }
  .el-menu-item:hover{
    background: none !important;
  }
  .menuBtn{
    display: flex;
    align-items: center;
    img{
      &:first-child{
        margin-right:15px;
      }
      width:18px;
    }
  }
  .userName{
    max-width:200px;
    white-space: pre-wrap; 
    line-height:20px;
    height: 50px;
    font-size:16px;
    display: flex;
    align-items: center;
  }
</style>
